var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CHANGE_SIDEBAR_WIDTH } from '../actions/layoutSidebar.actions';
var layoutSidebarReducer = function (state, _a) {
    if (state === void 0) { state = {
        width: 240,
    }; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case CHANGE_SIDEBAR_WIDTH:
            return __assign(__assign({}, state), { width: state.width + payload.width > 500 ? 500 : state.width + payload.width });
        default:
            return state;
    }
};
export default layoutSidebarReducer;



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/layoutSidebar.reducer.ts
// module id = 1488
// module chunks = 81